export enum INPUT_STATUS {
  ERROR = "error",
  SUCCESS = "success",
  WARNING = "warning",
}
